<script>

import {createEventDispatcher } from 'svelte';
import TermoUso from './termodeuso.svelte';
export let email="";
export let nome="";
export let senha="";
export let statusErro=false;
export let cadastrar=true;
export let statusCadastro=0;
const dispatch = createEventDispatcher();
let open = false;
  const toggle = () => (open = !open);
let emailConfirmacao="";
let senhaConfirmacao="";
let senhaConfere=0;
let emailConfere=0;
let validacaoGeral=false;
;

function Cadastro(e){
    e.preventDefault();
    validacaoGeral=false;
    dispatch("ChamarCadastro");
    
}
function ChecaSenha(){
senhaConfere=1;
statusCadastro=0;
console.log(senha+" senha "+ senha.length);
if(senha.length<6 || senha.length>256){
    senhaConfere=3;
    return;
}

if(senhaConfirmacao==senha && senha!=""){
    senhaConfere=2;
}else if (senha=="" || senhaConfere==""){
    senhaConfere=0;

}
}

function MudaToggle(e){
    e.preventDefault();
    open=!open;
     validacaoGeral=false;
}
function ValidaEmail(){
   emailConfere=0;
   const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if(!re.test(String(email).toLowerCase())){
    emailConfere=3;
 statusCadastro=0;
}

}
function ChecaEmail(){
if (emailConfere==3){
    return;
}
emailConfere=1;
statusCadastro=0;

if(emailConfirmacao==email && email!=""){
    emailConfere=2;
}else if (email=="" || emailConfere==""){
    emailConfere=0;

}
}
function Voltar(e){
    e.preventDefault();
    console.log("chamando voltar");
    dispatch("ChamarTela","login");
}
function ValidacaoGeral(e){
    e.preventDefault();
validacaoGeral=false;
    ValidaEmail();
    ChecaEmail();
    ChecaSenha();
if(emailConfere==2 && senhaConfere==2 && nome!="" && nome.length>2){
    validacaoGeral=true;
}

}
 
import {Button,
    ButtonGroup,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader} from 'sveltestrap';


function ChamarTela(e){
    dispatch("ChamarTela",e);
}
</script>
<style>
/* Bordered form */
/* Made with love by Mutiullah Samim*/

@import url('https://fonts.googleapis.com/css?family=Numans');
body{
      
    background-color: black}
.back{
background-image: url('../img/back.jpg');
background-size: cover;
background-repeat: no-repeat;

height: 100%;
padding: 10px;
font-family: 'Numans', sans-serif;

}

.container{
height: 100%;
align-content: center;
}

.card{
height: 430px;
margin-top:100px;
margin-bottom: 300px;
width: 400px;
background-color: rgba(0,0,0,0.5) !important;
}

.social_icon span{
font-size: 60px;
margin-left: 10px;
color: #FFC312;
}

.social_icon span:hover{
color: white;
cursor: pointer;
}

.card-header h3{
color: white;
}

.social_icon{
position: absolute;
right: 20px;
top: -45px;
}

.input-group-prepend span{
width: 50px;
background-color: #FFC312;
color: black;
border:0 !important;
}

input:focus{
outline: 0 0 0 0  !important;
box-shadow: 0 0 0 0 !important;

}

.remember{
color: white;
}

.remember input
{
width: 20px;
height: 20px;
margin-left: 15px;
margin-right: 5px;
}

.login_btn{
color: black;
background-color: #FFC312;
width: 100px;
}

.login_btn:hover{
color: black;
background-color: white;
}

.links{
color: white;
}
.links a{
margin-left: 4px;
}
.tabular{
   margin-left:10px;

}
.modal-body{
    height: 250px;
    
}
.scrool{
    height: 200px;
    overflow-y: auto;
    padding-right: 50px
}
</style>
<section>
<body class='back'>
<div class=" container ">
	<div class="d-flex justify-content-center h-100 ">
		<div class="card ">
			<div class="card-header">
				<h3>Cadastrar</h3>
                <!--
				<div class="d-flex justify-content-end social_icon">
					<span><i class="fab fa-facebook-square"></i></span>
					<span><i class="fab fa-google-plus-square"></i></span>
					<span><i class="fab fa-twitter-square"></i></span>
				</div>-->
			</div>
			<div class="card-body">
				<form >
					<div class="input-group form-group">
						<div class="input-group-prepend">
							
						</div>
						<input type="text" class="form-control" placeholder="Nome Completo" bind:value={nome}>
						
					</div>
                    <div class="input-group form-group">
						<div class="input-group-prepend">
							
						</div>
						<input type="text" class="form-control" placeholder="Email"  bind:value={email} on:input={ValidaEmail}>
						
					</div>
                    <div class="input-group form-group">
						<div class="input-group-prepend">
							
						</div>
						<input type="text" class="form-control" placeholder="Repetir email"  bind:value={emailConfirmacao} >
						
					</div>
					<div class="input-group form-group">
						<div class="input-group-prepend">
							
						</div>
						<input type="password" class="form-control" placeholder="Senha" bind:value={senha}>
					</div>
                    <div class="input-group form-group">
						<div class="input-group-prepend">
							
						</div>
						<input type="password" class="form-control" placeholder="Confirmar senha"  bind:value={senhaConfirmacao}  > 
					</div>
					<div class="row align-items-center remember">
                   
                    {#if statusCadastro==3}
                    <span class="tabular">Erro na comunicação</span>
                    {:else if statusCadastro==2}
                     <span class="tabular">Já consta esse login em nosso sistema</span>
                    {:else if senhaConfere==1}
                     <span class="tabular">Senhas não conferem</span>
                     {:else if emailConfere==3}
                     <span class="tabular">Formato inválido de email</span>
                      {:else if senhaConfere==3}
                     <span class="tabular">Senha não pode ter menos que 6 caracteres</span>
                     {:else if emailConfere==1}
                     <span class="tabular">Emails não conferem</span>
                    {/if}
						<!--<input type="checkbox">Lembrar me-->
					</div>
                    
					<div class="form-group">
                
                              <input type="submit" on:click={(e)=>ValidacaoGeral(e)}  value="Salvar" class="tabular  btn float-right login_btn"> 
                              <button  on:click={(e)=>Voltar(e)}  value="Voltar" class="btn float-right login_btn">Voltar</button>
                  
                          
                            
                           <Modal isOpen={validacaoGeral} class="modal-body scrool">
                            <ModalHeader {open}>Termos de uso</ModalHeader>
                                <div class="scrool" >
                                 <TermoUso />
                                
                                </div>
                                <ModalFooter>
                                
                                <Button color="secondary" on:click={(e)=>ChamarTela("login")}>
                                    Cancelar
                                </Button>
                                <Button color="primary" on:click={(e)=>Cadastro(e)}>
                                    Concordo com os termos  
                                </Button> 
                                </ModalFooter>           </Modal> 

                        
					</div>
				</form>
			</div>

            <!---
			<div class="card-footer">
				<div class="d-flex justify-content-center links">
					Não tem uma conta?<a href="#">Cadastre-se</a>
				</div>
				<div class="d-flex justify-content-center">
					<a href="#">Esqueci a senha</a>
				</div>
			</div>-->
		</div>
	</div>
</div>


</body>

</section>
